import { HTTPClient } from '@abaco/web-common/src/HTTP';

export default class HelperApi {
    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public async setDoNotShowAnymore(): Promise<boolean> {
        const url = "/sitiagri-rest-api/api_basic/v1/user_registry/module_competencies";
        const params = {
            software: "PORTAL",
            module: "WELCOME_PATH"
        }
        const res = await this.http.post(url, params)
        return res.data.result;
    }

    public async alreadyDone(): Promise<boolean> {
        const url = "/sitiagri-rest-api/api_basic/v1/user_registry/module_competencies/PORTAL/WELCOME_PATH";
        const res = await this.http.get(url);
        return res.data.result;
    }
}
